import { useEffect, useMemo, useRef, useState } from 'react';
import './ComponentView.css';
import { useNavigate } from 'react-router-dom';

const ComponentView = ({ view }) => {
  const { view_id, embed_url, display_name, description, page_sequence, view_dimensions } = view;
   const [iframeLoaded, setIframeLoaded] = useState(false);
    const [iframeHeight, setIframeHeight] = useState(
    parseInt(view_dimensions?.height) || 600
  );
  const iframeRef = useRef(null);

   console.log("embed_url for", display_name, ":", embed_url);

  const navigate = useNavigate();

  // Memoize URL to avoid unnecessary iframe reloads
  const iframeUrl = useMemo(() => {
    return embed_url;
  }, [embed_url]);

  useEffect(() => {
    const handler = (event) => {
      // 🔐 Optional: restrict origin (recommended in prod)
      // if (event.origin !== "https://appsmith.seedsfincap.in") return;
      
      // console.log("FULL EVENT:", event);
      // console.log("DATA RECEIVED:", event.data);

      if (event.data?.type === "STAGE_CLICK") {
        const stage = event.data.stage;

        console.log({ stage });

        navigate(`/analytics/${encodeURIComponent(stage)}`);
      }
    };

    window.addEventListener("message", handler);

    return () => window.removeEventListener("message", handler);
  }, [navigate]);

  return (
    <div className="view-container">
      {/* <h3 className='view-name'>{display_name}</h3> */}

      {/* Loader */}
      {!iframeLoaded && (
        <div className="iframe-loader">
          Loading dashboard...
        </div>
      )}

      <iframe
        // src={embed_url}
        ref={iframeRef}
        src={iframeUrl}
        title={display_name}
        loading="lazy"
        onLoad={() => setIframeLoaded(true)}
        className="appsmith-iframe"
        style={{
          width: '100%',
          height: `${iframeHeight}px`,
          border: 'none',
          opacity: iframeLoaded ? 1 : 0,
          transition: 'opacity 0.3s ease, height 0.2s ease'
        }}
      />
    </div>
  );
};

export default ComponentView;
